"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Colours = _interopRequireWildcard(require("@/helpers/Colours"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  props: ['ircinput'],
  data: function data() {
    return {};
  },
  methods: {
    onColourClick: function onColourClick(event) {
      let colour = window.getComputedStyle(event.target, null).getPropertyValue('background-color');
      // Convert rgb(x,x,x) to its hex form
      let m = colour.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (m) {
        let rgbObj = {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        };
        colour = Colours.rgb2hex(rgbObj);
      }
      let code = event.target.dataset.code;
      this.ircinput.setColour(code, colour);
    },
    onResetClick: function onResetClick() {
      this.ircinput.resetStyles();
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["inputtools"]) window._app_exports["components"]["inputtools"] = {};
window._app_exports["components"]["inputtools"]["TextStyle"]
window._app_exports.components.inputtools.TextStyle = exports.default ? exports.default : exports;
